/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 20/04/22
 */

import React from 'react';
import { Column, ListTable } from '@/components/pages/dashboard/tiles/bottomTile/bottomTileTables/ListTable';
import { Assignment } from '@/wpt-lib/interfaces/Assignment';
import Icons from '@/components/icons/Icons';
import { formatFirstName, formatName } from '@/wpt-lib/utils/formatName';

interface FacultyAdminListTableProps {
    admins: Assignment[];
    actionsDisabled?: boolean;
    onRemove(assignment: Assignment): void;
}

const FacultyAdminListTableColumns: Column<Assignment>[] = [
    {
        name: 'Staff Id',
        getData: (assignment) => assignment.user?.staffId,
    },
    {
        name: 'Preferred Name',
        getData: (assignment) => formatFirstName(assignment.user),
    },
    {
        name: 'Last Name',
        getData: (assignment) => assignment.user?.lastName,
    },
    {
        name: 'Assignment',
        getData: (assignment) => `${assignment.assignmentNumber} - ${assignment.name}`,
    },
];

const LocalAdminListTable = (props: FacultyAdminListTableProps) => {
    return (
        <ListTable
            tableCaption=""
            columns={FacultyAdminListTableColumns}
            getActions={(item) => [
                {
                    id: 'remove',
                    label: 'Remove',
                    icon: <Icons.DeleteIcon />,
                    event: (assignment) => {
                        props.onRemove(assignment);
                    },
                    ariaLabel: `Remove ${formatName(item.user)}`,
                    isDisabled: () => !!props.actionsDisabled,
                },
            ]}
            data={props.admins}
        />
    );
};

export default LocalAdminListTable;
